import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Heart, Instagram, Facebook, Youtube } from 'lucide-react';
import logo from '../assets/logo.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-blobs">
        <div className="blob" style={{ width:300, height:300, background:'var(--laranja)', top:'-80px', left:'-60px' }} />
        <div className="blob" style={{ width:200, height:200, background:'var(--rosa)', bottom:'-40px', right:'-40px' }} />
      </div>

      <div className="container footer-inner">
        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="Instituto Mãos Estendidas" className="footer-logo-img" />
            <div>
              <span className="footer-logo-top">Instituto</span>
              <span className="footer-logo-main">Mãos Estendidas</span>
            </div>
          </div>
          <p className="footer-desc">
            Organização não governamental de direito privado, comprometida com o desenvolvimento
            social e humano de Marabá e região.
          </p>
          <div className="footer-socials">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="https://facebook.com"  target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={18} /></a>
            <a href="https://youtube.com"   target="_blank" rel="noopener noreferrer" aria-label="YouTube"><Youtube size={18} /></a>
          </div>
          <p className="footer-cnpj">CNPJ: 45.334.670/0001-82</p>
        </div>

        {/* Navegação */}
        <div className="footer-col">
          <h4>Navegação</h4>
          <ul>
            <li><Link to="/">Início</Link></li>
            <li><Link to="/quem-somos">Quem Somos</Link></li>
            <li><Link to="/projetos">Projetos</Link></li>
            <li><Link to="/noticias">Notícias</Link></li>
            <li><Link to="/galeria">Galeria</Link></li>
          </ul>
        </div>

        {/* Transparência */}
        <div className="footer-col">
          <h4>Transparência</h4>
          <ul>
            <li><Link to="/documentos">Documentos</Link></li>
            <li><Link to="/documentos?categoria=relatorio">Relatórios</Link></li>
            <li><Link to="/documentos?categoria=estatuto">Estatuto</Link></li>
            <li><Link to="/documentos?categoria=ata">Atas</Link></li>
            <li><Link to="/contato">Contato</Link></li>
          </ul>
        </div>

        {/* Contato */}
        <div className="footer-col footer-contato">
          <h4>Contato</h4>
          <div className="footer-info">
            <MapPin size={15} />
            <span>Rua Amanda Rocha Mesquita de Oliveira, Quadra 19, Lote 07 – Residencial Tiradentes, Marabá – PA</span>
          </div>
          <div className="footer-info">
            <Mail size={15} />
            <a href="mailto:contato@maosestendidas.org.br">contato@maosestendidas.org.br</a>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {new Date().getFullYear()} Instituto Mãos Estendidas. Todos os direitos reservados.</p>
          <div className="footer-bottom-right">
            <p className="footer-dev">Feito com <Heart size={12} fill="currentColor" /> para transformar vidas</p>
            <Link to="/admin/login" className="footer-admin-link">.</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}